module.exports = "/_next/static/images/south-carolina-5aec9282b1484b2f15c0684eb44771ba.svg";